import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../data/coaching";

export const PORTFOLIO_SEO = {
  title: "Bluebloodfr — Louis-Melchior Giraud | Data Scientist & AI Engineer",
  description:
    "Louis-Melchior Giraud (Bluebloodfr) — Data Scientist & AI Engineer. Reliable AI, data and software solutions for real-world use cases.",
  ogTitle: "Bluebloodfr — Louis-Melchior Giraud | Data Scientist & AI Engineer",
  ogDescription: "Reliable AI, data and software solutions for real-world use cases.",
  lang: "en",
  ogLocale: "en_GB",
  canonical: `${SITE_URL}/`,
  image: `${SITE_URL}/og-preview.jpg`,
};

export const Seo = ({
  title,
  description,
  ogTitle,
  ogDescription,
  lang = "en",
  ogLocale,
  canonical,
  image,
  imageWidth,
  imageHeight,
  imageAlt,
  twitterSite,
  alternates = [],
  jsonLd,
  noindex = false,
}) => (
  <Helmet htmlAttributes={{ lang }}>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    {noindex && <meta name="robots" content="noindex, nofollow" />}
    {canonical && <link rel="canonical" href={canonical} />}
    {alternates.map((a) => (
      <link key={a.hrefLang} rel="alternate" hrefLang={a.hrefLang} href={a.href} />
    ))}
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Bluebloodfr" />
    <meta property="og:title" content={ogTitle || title} />
    {(ogDescription || description) && (
      <meta property="og:description" content={ogDescription || description} />
    )}
    {canonical && <meta property="og:url" content={canonical} />}
    {ogLocale && <meta property="og:locale" content={ogLocale} />}
    {image && <meta property="og:image" content={image} />}
    {imageWidth && <meta property="og:image:width" content={imageWidth} />}
    {imageHeight && <meta property="og:image:height" content={imageHeight} />}
    {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
    <meta name="twitter:card" content="summary_large_image" />
    {twitterSite && <meta name="twitter:site" content={twitterSite} />}
    <meta name="twitter:title" content={ogTitle || title} />
    {(ogDescription || description) && (
      <meta name="twitter:description" content={ogDescription || description} />
    )}
    {image && <meta name="twitter:image" content={image} />}
    {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
  </Helmet>
);

export default Seo;
